module.exports = __webpack_public_path__ + "img/rec-04.c720fde0.jpg";